import type { CityConfig } from "@/pages/city-template/types";

export const binghamtonConfig: CityConfig = {
  city: "Binghamton",
  state: "New York",
  stateAbbr: "NY",
  slug: "binghamton",
  route: "/cities/binghamton",
  title: "Emergency & Expedited Passport Binghamton NY | Southern Tier",
  metaDescription:
    "Emergency passport Binghamton NY — same day, 24-hour, and 3-5 day expedited passport processing for Broome County and the Southern Tier. Fast Passport Center serves Binghamton, Johnson City, Vestal, Endicott, and all surrounding communities.",
  h1: "Emergency & Expedited Passport Services in Binghamton, NY",
  heroSubtitle:
    "Binghamton's fast passport solution — from the Southern Tier to the Twin Tiers. Whether you're flying out of Binghamton Airport or Syracuse Hancock, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Binghamton%20New%20York%20skyline%20with%20the%20Susquehanna%20River%20flowing%20through%20the%20city%2C%20historic%20Court%20Street%20and%20downtown%20buildings%2C%20SUNY%20Binghamton%20campus%20visible%20in%20distance%2C%20autumn%20foliage%20colors%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20scenic%20upstate%20New%20York%20city%20with%20river%20and%20hills&width=1600&height=700&seq=ny-binghamton-hero-001&orientation=landscape",
  heroImageAlt: "Binghamton New York skyline with the Susquehanna River and downtown at golden hour",
  geoPosition: "42.0987; -75.9180",
  geoPlacename: "Binghamton, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~175 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Binghamton", zips: "13901-13905, 13901, 13902, 13903, 13904, 13905" },
    { name: "Johnson City", zips: "13790" },
    { name: "Vestal", zips: "13850, 13851" },
    { name: "Endicott", zips: "13760, 13761, 13763" },
    { name: "Endwell", zips: "13762" },
    { name: "Port Dickinson", zips: "13901" },
    { name: "Chenango Bridge", zips: "13745" },
    { name: "Kirkwood", zips: "13795" },
    { name: "Conklin", zips: "13748" },
    { name: "Kirkwood", zips: "13795" },
    { name: "Corbettsville", zips: "13745" },
    { name: "Syracuse", zips: "13201-13210, 13211, 13212, 13214, 13215, 13217, 13218, 13219, 13220, 13224, 13225, 13235, 13244, 13250, 13251, 13252, 13261, 13290" },
    { name: "Ithaca", zips: "14850, 14851, 14852, 14853" },
    { name: "Elmira", zips: "14901, 14902, 14903, 14904, 14905, 14925" },
    { name: "Corning", zips: "14830, 14831" },
    { name: "Oneonta", zips: "13820" },
    { name: "Watertown", zips: "13601, 13602, 13603" },
    { name: "Utica", zips: "13501, 13502, 13503, 13504, 13505, 13599" },
    { name: "Rome", zips: "13440, 13441, 13442" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230, 12231, 12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
    { name: "Rochester", zips: "14602, 14603, 14604, 14605, 14606, 14607, 14608, 14609, 14610, 14611, 14612, 14613, 14614, 14615, 14616, 14617, 14618, 14619, 14620, 14621, 14622, 14623, 14624, 14625, 14626, 14627, 14642, 14650, 14652, 14653, 14692" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
    { name: "Scranton", zips: "18501, 18502, 18503, 18504, 18505, 18507, 18508, 18509, 18510, 18512, 18514, 18515, 18517, 18518, 18519, 18577" },
    { name: "Wilkes-Barre", zips: "18701, 18702, 18703, 18704, 18705, 18706, 18711, 18761, 18762, 18764, 18766, 18767, 18769, 18773" },
    { name: "Pittston", zips: "18640, 18641, 18642, 18643, 18644" },
    { name: "Hazleton", zips: "18201, 18202" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Binghamton travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Binghamton residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Broome County & Southern Tier",
      desc: "Binghamton, Johnson City, Vestal, Endicott, and all of Broome County and the Southern Tier — we serve all of upstate New York.",
    },
  ],
  testimonials: [
    {
      name: "Patricia W.",
      location: "Vestal, NY",
      rating: 5,
      text: "Had a family emergency overseas and needed my passport within 3 days. Fast Passport Center delivered in 2. They walked me through every step since I was nervous about the process.",
      service: "Emergency Passport",
    },
    {
      name: "Michael T.",
      location: "Johnson City, NY",
      rating: 5,
      text: "Renewed my expired passport for a business trip to Toronto. Chose the 5-day option and had it back in 4. They reviewed everything before submission.",
      service: "Passport Renewal",
    },
    {
      name: "Sandra L.",
      location: "Endicott, NY",
      rating: 5,
      text: "First-time passport for my son's college study abroad in Spain. The agent walked us through the DS-11 form and acceptance clerk process. Processed in 5 days.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "binghamton-1",
      name: "Binghamton Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "15 Chenango Street",
      city: "Binghamton",
      state: "NY",
      zip: "13901",
      phone: "607-772-2161",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Downtown Binghamton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Binghamton passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "binghamton-2",
      name: "Johnson City Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "254 Floral Avenue",
      city: "Johnson City",
      state: "NY",
      zip: "13790",
      phone: "607-729-1191",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Johnson City (adjacent to Binghamton)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Johnson City and west Binghamton residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "binghamton-3",
      name: "Vestal Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "3301 Vestal Parkway East",
      city: "Vestal",
      state: "NY",
      zip: "13850",
      phone: "607-785-2205",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Vestal (south of Binghamton)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Vestal, Endicott, Endwell, and Southern Tier communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Binghamton?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Binghamton residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Binghamton?",
      a: "The Binghamton Post Office at 15 Chenango Street is the major passport acceptance facility. The Johnson City Post Office at 254 Floral Avenue and Vestal Post Office at 3301 Vestal Parkway East are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Binghamton?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout Binghamton and Broome County including Johnson City, Vestal, and Endicott. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Binghamton?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Binghamton passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. Binghamton residents can simply ship documents via overnight courier. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Binghamton?",
      a: "The fastest way to renew a passport in Binghamton is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Binghamton?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Binghamton and all Broome County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Binghamton?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Binghamton. We serve the Southern Tier and all of Broome County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Binghamton", address: "various CVS locations across Binghamton, Johnson City, Vestal, and Endicott", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Binghamton", address: "various Walgreens locations throughout Binghamton and Broome County", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Binghamton", address: "various UPS Store locations in Binghamton and Vestal", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Binghamton", address: "various FedEx Office locations across Binghamton and the Southern Tier", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart Photo Center — Binghamton", address: "Walmart locations in Binghamton and Johnson City", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Binghamton",
      address: "33 Lewis Street, Binghamton, NY 13901",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Binghamton DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Endicott",
      address: "3210 North Street, Endicott, NY 13760",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Endicott DMV office serving west Binghamton, Endicott, and Endwell residents.",
      featured: false,
    },
    {
      name: "NYS DMV — Vestal",
      address: "2407 Vestal Parkway East, Vestal, NY 13850",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Vestal DMV office serving south Binghamton, Vestal, and Johnson City communities.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BGM",
      name: "Greater Binghamton Airport",
      distance: "In Binghamton, NY",
      address: "2534 Airport Road, Johnson City, NY 13790",
      note: "Binghamton's primary airport with flights to Detroit, Philadelphia, and Washington DC. Perfect for Binghamton and Southern Tier travelers.",
      flightUrl: "https://www.flybgm.com/",
      flightLabel: "BGM Airport",
      featured: true,
    },
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "~75 miles from Binghamton",
      address: "1000 Col Eileen Collins Blvd, Syracuse, NY 13212",
      note: "Upstate New York airport with flights to major U.S. cities and international destinations. Alternative for Binghamton area travelers.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "Syracuse Airport",
      featured: false,
    },
    {
      code: "AVP",
      name: "Wilkes-Barre/Scranton International Airport",
      distance: "~70 miles from Binghamton",
      address: "100 Terminal Drive, Avoca, PA 18641",
      note: "Pennsylvania airport with flights to major U.S. hubs. Alternative for Binghamton area travelers heading south.",
      flightUrl: "https://www.flyavp.com/",
      flightLabel: "AVP Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Binghamton travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Binghamton residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Binghamton residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Binghamton residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Binghamton, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Binghamton residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Binghamton travelers with immediate departure needs from Greater Binghamton Airport or Syracuse." },
    { name: "Passport Renewal", description: "Fast passport renewal for Binghamton residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Binghamton residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Binghamton residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Binghamton and Broome County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Binghamton." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Binghamton travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Binghamton travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Binghamton team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier from Binghamton to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Binghamton address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Staten Island", route: "/cities/staten-island" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Binghamton and all of the Southern Tier as a remote courier service. We do not have a physical office in Binghamton, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeDistance: "Remote courier service — Binghamton area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Binghamton and all of Broome County. From Johnson City to Vestal, from Endicott to Endwell — we serve the Southern Tier and Twin Tiers with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Binghamton and all surrounding communities across Broome County and the Southern Tier. Whether you're in Johnson City, Vestal, or Endicott, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Binghamton customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Binghamton travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Binghamton travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Binghamton. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
};

export default binghamtonConfig;